export const ASSETS = {
  video: 'https://customer-assets-0z36b82j.emergentagent.net/job_concentrated-citrus/artifacts/ncklwfv9_Angry%20Tangerine%20Commercial%20v1.MP4',
  bottle: '/assets/bottle.jpg',
  bottleHero: '/assets/bottle-hero.jpg',
  labelWrap: '/assets/label-wrap.jpg',
  petsTrio: '/assets/pets-trio.jpg',
  petsPoodle: '/assets/pets-poodle.jpg',
  petsCorgi: '/assets/pets-corgi.jpg',
  artGallon: '/assets/makes-infographic.jpg',
  artMixSpray: '/assets/mix-spray.jpg',
  artSurfaces: '/assets/poodle-surfaces.jpg',
  artFormula: '/assets/corgi-formula.jpg',
  posterPets: '/assets/husky-poster.jpg',
  catStudio: '/assets/cat-studio.jpg',
  dogLabrador: '/assets/dog-labrador.jpg',
  catDark: '/assets/cat-dark.jpg',
  dogTable: '/assets/dog-table.jpg',
};
